import type { SizeValue } from '../components/BlotterTable/aggFuncs/types';
import type { Currency } from '../types/Currency';
import { toBig } from './number';

export type AvailableMarginRow = {
  AvailableMarginToBuy?: string;
  AvailableMarginToSell?: string;
  MarginCurrency?: string;
};

/**
 * Available margin = min(AvailableMarginToBuy, AvailableMarginToSell).
 * Returns empty if either side is missing or not parseable — both must be present.
 */
export function getAvailableMargin(data: AvailableMarginRow | undefined): string {
  if (!data) {
    return '';
  }
  const buy = toBig(data.AvailableMarginToBuy);
  const sell = toBig(data.AvailableMarginToSell);
  if (buy == null || sell == null) {
    return '';
  }
  return buy.lte(sell) ? buy.toFixed() : sell.toFixed();
}

/**
 * Size column value for AG Grid: numeric string plus display currency and increment from context.
 * Matches size column behavior for `currencyField: 'MarginCurrency'`.
 */
export function getAvailableMarginSizeValue(
  data: AvailableMarginRow | undefined,
  context: { current: { currenciesBySymbol?: Map<string, Currency> } }
): SizeValue {
  const value = getAvailableMargin(data);
  const currencyKey = data?.MarginCurrency ?? '';
  const currencyInfo = currencyKey ? context.current.currenciesBySymbol?.get(currencyKey) : undefined;
  return {
    value,
    currency: currencyInfo?.Symbol ?? currencyKey,
    increment: currencyInfo?.DefaultIncrement,
  };
}
